<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 6h-1V4a2 2 0 00-2-2H9a2 2 0 00-2 2v2H6a4 4 0 00-4 4v9a1 1 0 001 1h18a1 1 0 001-1v-9a4 4 0 00-4-4zM9 4h6v2H9zm11 14H4v-4.95h3.5V14a.5.5 0 001 0v-.95h7V14a.5.5 0 001 0v-.95H20zm0-5.95h-3.5V11a.5.5 0 00-1 0v1.05h-7V11a.5.5 0 00-1 0v1.05H4V10a2 2 0 012-2h12a2 2 0 012 2z"/></svg>